import {
  anAddItemToSuppressList,
  anItemMeta,
  aSuppressListItem,
  mockAddItemToSuppressedListOperationMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const addSuppressedListItemHandler = ({
  id,
  value,
  description,
  expiration,
}) => ({
  __typename: 'Mutation',
  addItemToSuppressList: anAddItemToSuppressList({
    finishedProcessing: true,
    data: aSuppressListItem({
      id,
      value,
      expiration,
      meta: anItemMeta({ description }),
    }),
  }),
});

export const handlers = [
  mockAddItemToSuppressedListOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Mutation',
          addItemToSuppressList: anAddItemToSuppressList({
            finishedProcessing: true,
          }),
        },
      });
    }
  ),
];
